<div *transloco="let t" class="cheat-sheet-drawer">
  <app-nav-button
    icon="close"
    (clickEvent)="onCloseClick()"
    [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
    [size]="drawerConfig.closeButtonSize"
    [ngClass]="drawerConfig.closeButtonPosition"
  />
  <div class="cheat-sheet-drawer-content">
    <div [ngStyle]="titleStyles | theme" class="cheat-sheet-title">
      {{ t("components.cheat-sheet.title") }}
    </div>

    <div class="rules-container">
      @for (cheatSheet of cheatSheets; track cheatSheet; let i = $index) {
        <div>
          <div class="center-children">
            <div class="content-width">
              <div class="heading" [ngStyle]="headerStyles | theme">
                {{ t(cheatSheet.title) }}
              </div>
              @for (item of cheatSheet.body; track item) {
                <div>
                  @if (item.type === "text" && item.content !== undefined) {
                    <div class="body" [ngStyle]="bodyStyles | theme">
                      {{ t(item.content) }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
